var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGhs09 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Milj\\xF8 9",
  viewBox: "0 0 567 567",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M289.5 572.52 573 289 289.5 5.52 6 289Z",
  style: {
    fill: "red"
  },
  transform: "translate(-6 -5.52)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.5 527.55 51 289.1 289.5 50.64 528 289.1Z",
  style: {
    fill: "#fff"
  },
  transform: "translate(-6 -5.52)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.26 288.86H397.7",
  style: {
    strokeWidth: "3.94px",
    stroke: "#000",
    strokeMiterlimit: 3.94
  },
  transform: "translate(-6 -5.52)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m364.47 328.87 26 18.73-24.69 11.89 33.23 3-9 11.89h18.35l.43 13.2-231.67-1.28s38.75-11.48 45.13-6.8c8.52-3.83 70.75-30.24 70.75-28.5m-59.62-20.45 1.27-67.26L201 245a15.48 15.48 0 0 0-12.35-1.27c-2.56.85-6 1.7-6 1.7s18.35-15.33 21.72-14.05 27.25 12.77 27.25 12.77-2.56-17.88-8.94-23-31.08-24.7-31.08-24.7v-4.68l33.64 20.44s1.27-19.59-5.51-31.08-11.9-21.72-11.9-21.72l2.13-1.7 16.62 25.54 5.51-17.48 3.41-.85s-4.26 24.7-1.28 32.37 14.05 49.4 14.05 49.4l16.62-23.87a123.82 123.82 0 0 0-.43-16.61c-.85-6.81-2.12-38.33-2.12-38.33h3l4.66 34.51 26.85-31.08v3.41S270.48 208 271.76 215.2s2.55 11.5-2.13 21.72S262 254.4 262 254.4s14-16.62 20.44-17.88c6.39-.43 14.89.42 20.86-4.69s20.44-21.26 20.44-21.26l-22.57 34.88s-10.64.43-14.89 5.11-21.72 24.7-21.72 24.7v46l29 14.47-35.34 5.12-8.52 12.34-11.5-9.79-32 2.94Z",
  style: {
    strokeWidth: "3.15px",
    stroke: "#000",
    strokeMiterlimit: 3.94
  },
  transform: "translate(-6 -5.52)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.81 350.21c8.11-3.38 21.27-8.95 28.95-20 8-11.45 36.2-59.62 75-55.76-2.12 5.11-8.94 16.19-8.94 16.19l27.64-8.52s.42 36.61-51.95 60c-24.27 8.52-29.38 8.95-31.5 11.89s-11.9 17.89-11.9 17.89l-43.42-19.14s11.07-.4 16.15-2.53Z",
  style: {
    strokeWidth: "3.94px",
    stroke: "#000",
    strokeMiterlimit: 3.94,
    fill: "#fff"
  },
  transform: "translate(-6 -5.52)"
}), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 375.48,
  cy: 297.99,
  rx: 4.69,
  ry: 4.04
})));
export default SvgGhs09;